<template>
  <div class="content-wrapper">    
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Reengagement Manager
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li>Reengagement Manager</li>
        <li class="active">Reengagement List</li>
      </ol>      
    </section>

    <!-- Main content -->
    <section class="content">   
      <div class="row">
        <div class="col-md-12">
          <div class="box box-default margin-bottom-0px">
            <div class="box-header with-border">
              <div class="action-button pull-right">
                <div class="form-group col-xs-12 col-sm-3" style="flex-wrap: nowrap !important;">
                  
                     <label for="date-from">Start Date</label>
                    <div class="input-group">
                        <input :max="toDt" type="date"  id="date-from" class="form-control" placeholder="From" v-model="fromDt" v-on:keyup="searchReengagementWithSelectedCriteria" @change="searchReengagementWithSelectedCriteria" />
                        <span class="input-group-addon" id="basic-addon2"><i class="fa fa-times" aria-hidden="true" @click="clearDate('fromDt')" ></i></span>
                    </div>
                </div>
                <div class="form-group col-xs-12 col-sm-3">
                    <label for="date-to">End Date</label>
                     <div class="input-group">
                        <input :min="fromDt" type="date" id="date-to" class="form-control" placeholder="To" v-model="toDt" v-on:keyup="searchReengagementWithSelectedCriteria" @change="searchReengagementWithSelectedCriteria" />
                        <span class="input-group-addon" id="basic-addon2"><i class="fa fa-times" aria-hidden="true" @click="clearDate('toDt')"></i></span>
                    </div>
                 </div>
                  <div class="form-group col-xs-12 col-sm-6 search-reengagement">
                    <label for="date-to">Search</label>
                    <div>
                      <input type="text" placeholder="Type here to search and press 'Enter'"
                        class="search-box-reset form-control mrgn-right-20px searchBox" 
                        v-model="searchReengagement"
                        v-reset-input='' v-on:keyup="searchReengagementWithSelectedCriteria"
                        />
                    </div>
                  </div>
                    <div class="form-group col-xs-12 col-sm-6 create-reengagement">
                    <label for="date-to"></label>
                    <router-link class="btn btn-primary" :to="`/reengagement-manager/create`">Create Reengagement</router-link>
                  </div></div>
            </div>
              <!-- /.box-header -->
            <div class="box-body">
              <ul class="nav nav-tabs" role="tablist">
                <li role="presentation" class="active"><a href="#scheduled" aria-controls="scheduled" role="tab" data-toggle="tab">Scheduled Reengagements</a></li>
                <li role="presentation"><a href="#deployed" aria-controls="deployed" role="tab" data-toggle="tab">Deployed Reengagements</a></li>
                <li role="presentation"><a href="#failed" aria-controls="failed" role="tab" data-toggle="tab">Failed Reengagements</a></li>
              </ul>
               <div class="tab-content">
                <div role="tabpanel"  class="tab-pane active" id="scheduled">
                  <table class="table table-striped table-apps">
                    <thead class="thead-dark">
                      <th class="padding-left5px">Reengagement Name <i class="fa fa-long-arrow-up" @click="sortReengagement('campaign_name','asc', 'scheduled')"></i><i class="fa fa-long-arrow-down" @click="sortReengagement('campaign_name','desc', 'scheduled')"></i></th>
                      <th class="align-center">Created On (UTC)</th>
                      <th class="align-center">Country</th>
                      <th class="align-center">Scheduled On</th>
                      <th class="align-center">Status</th>
                      <th class="align-center"></th>
                      <th class="align-center">Clone/Copy </th>
                      <th class="align-center" >Report</th>
                      <th class="align-center">Edit</th>
                      <th class="align-center">Delete</th>
                    </thead>
                    <tbody>
                      <tr v-if="scheduledreengagementList.length === 0 && !loading"><td colspan="10" align="center">No Result found.</td></tr>
                      <tr v-show="scheduledreengagementList.length" v-for="(reengagement, index) in scheduledreengagementList" :key="index">
                        <td>{{reengagement.campaign_name}}</td>
                        <td class="align-center">{{formatDate(reengagement.createdAt, 'd/M/Y hh:ss',true)}}</td>
                        <td class="align-center">{{reengagement.country_name}}</td>
                        <td class="align-center">{{formatDate(reengagement.local_time, 'd/M/Y hh:ss')}}</td>
                        <td class="align-center">{{reengagement.status}}</td>
                        <td class="align-center"><input v-if="reengagement.group_list && reengagement.group_list.length" type="button" class="btn btn-primary btn-sm center"  @click="testNudgeClick(reengagement)" value="Send Test"></td>
                        <td class="align-center"><input type="button" class="btn btn-primary btn-sm center"  @click="openCopyModal(reengagement)" value="Copy"></td>
                        <td class="align-center">
                          <i v-if="reengagement.audience_id" v-on:click="getReengagementReport(reengagement, reengagementStatus.Scheduled)" class="fa fa-bar-chart" aria-hidden="true"></i>
                        </td>
                        <td class="align-center">
                           <router-link :to="`/reengagement-manager/${reengagement.id}`"><i class="fa fa-edit" aria-hidden="true"></i></router-link>
                        </td>
                        <td class="align-center">
                          <i class="fa fa-times-circle link-action-color" v-if="reengagement.status === 'Draft'" @click="openDeleteModal(reengagement.id)" aria-hidden="true"></i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="pagination-container">
                    <paginate v-if="schedulePageCount > 0"  :page-count="schedulePageCount" :click-handler="getDataForSchedulePage" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination'"></paginate>
                  </div> 
                </div>
                <div role="tabpanel" class="tab-pane" id="deployed">
                  <table class="table table-striped table-apps">
                    <thead class="thead-dark">
                      <th class="padding-left5px">Reengagement Name <i class="fa fa-long-arrow-up" @click="sortReengagement('campaign_name','asc', 'deployed')"></i><i class="fa fa-long-arrow-down" @click="sortReengagement('campaign_name','desc', 'deployed')"></i></th>
                      <th class="align-center">Created On (UTC)</th>
                      <th class="align-center">Country</th>
                      <th class="align-center">Scheduled On</th>
                      <th class="align-center">Status</th>
                      <th class="align-center">Clone/Copy </th>
                      <th class="align-center">Report</th>
                    </thead>
                    <tbody>
                     <tr v-if="deployedreengagementList.length === 0 && !loading"><td colspan="10" align="center">No Result found.</td></tr>
                    <tr v-show="deployedreengagementList.length" v-for="(reengagement, index) in deployedreengagementList" :key="index">
                      <td>{{reengagement.campaign_name}}</td>
                      <td class="align-center">{{formatDate(reengagement.createdAt, 'd/M/Y hh:ss',true)}}</td>
                      <td class="align-center">{{reengagement.country_name}}</td>
                      <td class="align-center">{{formatDate(reengagement.local_time, 'd/M/Y hh:ss')}}</td>
                      <td class="align-center">{{reengagement.status}}</td>
                      <td class="align-center"><input type="button" class="btn btn-primary btn-sm center"   @click="openCopyModal(reengagement)" value="Copy"></td>
                      <td class="align-center">
                          <i v-on:click="getReengagementReport(reengagement, reengagementStatus.Deployed)" class="fa fa-bar-chart" aria-hidden="true"></i>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="pagination-container">
                    <paginate v-if="deployPageCount > 0"  :page-count="deployPageCount" :click-handler="getDataForDeployPage" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination'"></paginate>
                  </div> 
                </div>
                <div role="tabpanel" class="tab-pane" id="failed">
                  <table class="table table-striped table-apps">
                    <thead class="thead-dark">
                      <th class="padding-left5px">Reengagement Name <i class="fa fa-long-arrow-up" @click="sortReengagement('campaign_name','asc', 'deployed')"></i><i class="fa fa-long-arrow-down" @click="sortReengagement('campaign_name','desc', 'deployed')"></i></th>
                      <th class="align-center">Created On (UTC)</th>
                      <th class="align-center">Country</th>
                      <th class="align-center">Scheduled On</th>
                      <th class="align-center">Status</th>
                      <th class="align-center">Clone/Copy </th>
                      <th class="align-center">Details</th>
                    </thead>
                    <tbody>
                     <tr v-if="failedreengagementList.length === 0 && !loading"><td colspan="10" align="center">No Result found.</td></tr>
                    <tr v-show="failedreengagementList.length" v-for="(reengagement, index) in failedreengagementList" :key="index">
                      <td>{{reengagement.campaign_name}}</td>
                      <td class="align-center">{{formatDate(reengagement.createdAt, 'd/M/Y hh:ss', true)}}</td>
                      <td class="align-center">{{reengagement.country_name}}</td>
                      <td class="align-center">{{formatDate(reengagement.local_time, 'd/M/Y hh:ss')}}</td>
                      <td class="align-center">{{reengagement.status}}</td>
                      <td class="align-center"><input type="button" class="btn btn-primary btn-sm center" @click="openCopyModal(reengagement)" value="Copy"></td>
                      <td class="align-center">
                          <i v-on:click="getReengagementReport(reengagement, reengagementStatus.Failed)" class="fa fa-bar-chart" aria-hidden="true"></i>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="pagination-container">
                    <paginate v-if="failePageCount > 0"  :page-count="failePageCount" :click-handler="getDataForFailPage" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination'"></paginate>
                  </div> 
                </div>
              </div>
            </div>
          </div>
        </div>  
      </div>       
    </section>

    <deployedReportModal 
      v-if="showDeployedReportModal"
      @close="closeReport(reengagementStatus.Deployed)"
      :reengagementReport="deployedReport"
      :campaignDetails="campaignDetails"
      />

    <scheduledReportModal 
      v-if="showScheduledReportModal"
      @close="closeReport(reengagementStatus.Scheduled)"
      :reengagementReport="scheduledReport" 
      :campaignDetails="campaignDetails"
      />

    <failedReportModal 
      v-if="showFailedReportModal"
      @close="closeReport(reengagementStatus.Failed)"
      :reengagementReport="failureReport"
      :campaignDetails="campaignDetails"
      />

    <form @submit.prevent="sendTestNudge"  method="post">
    <div class="modal-backdrop" v-if="audienceSelectionVisible" id="userSelection">
      <div class="modal modal-md modal-user-selection">
          <div class="test-nudge-container">
            <slot name="body">
              <div class="form-horizontal">

                <div class="row">
                  <div class="form-group col-xs-12 col-sm-12 col-md-12">
                    <label class="control-label modal-label" for="search">Select Group:</label>
                    &nbsp;&nbsp;
                    <div style="font-weight: bold;">Note: You can only select groups with Nudge and (Conversation or Keyword)</div>
                    <div style="display: flex; flex-flow: wrap;">
                      <div v-for="group in selectedReengagement.group_list" :key="group.group_name" style="width: 233px;">
                        <label class="radio-inline campaign-group-details" style="display: flex; flex-direction: column; margin-bottom: 10px; padding-left: 20px;"
                            v-bind:class="{'reengagement-group-disabled': !((group.keyword_id || group.conversation_id) && group.msg_template_id) }">
                          <input type="radio" v-model="selectedGroup" :value="group" :disabled="!((group.keyword_id || group.conversation_id) && group.msg_template_id)" />
                          <div>{{group.group_name}}</div>
                          <div>Nudge: <span class="campaign-details-text">{{group.msg_template_name ? group.msg_template_name : '-'}}</span></div>
                          <div v-if="group.conversation">Conversation: <span class="campaign-details-text">{{group.conversation ? group.conversation : '-'}}</span></div>
                          <div v-else>Keyword: <span class="campaign-details-text">{{group.keyword ? group.keyword : '-'}}</span></div>
                          <div>Destination: <span class="campaign-details-text">{{group.destination_app_name ? group.destination_app_name : '-'}}</span></div>
                          <div>Split Percent: <span class="campaign-details-text">{{group.split_percent || group.split_percent === 0 ? group.split_percent + '%' : '-'}}</span></div>
                        </label>
                      </div>
                    </div>
                    <span v-if="submittedTestNudge && !$v.selectedGroup.required" class="text-red pull-right" style="margin-right: 20px">Please select a group.</span>
                  </div>
                </div>   

                <div class="row">
                  <div class="form-group col-xs-12 col-sm-12 col-md-12">
                    <label class="control-label modal-label" for="search">Select test user(s):</label>
                    <label class="hint-text">Only onboarded users appear here. To include your account in a test, make sure you're currently onboarded to the correct country.</label>
                    &nbsp;&nbsp;
                    <div class="users-checkbox-container">
                      <div v-for="user in userList" :key="user.account_id">
                        <label class="checkbox-inline col-xs-6 col-sm-6 col-md-5 col-lg-4">
                          <input type="checkbox" v-model="selectedUsers" :value="user"/>{{user.account_name}}
                        </label>
                      </div>
                      <div v-if="!userList.length">There are no users </div>
                    </div>
                    <span v-if="submittedTestNudge && !$v.selectedUsers.required" class="text-red pull-right" style="margin-right: 20px">Please select users to send message.</span>
                  </div>
                </div>   

              </div>
            </slot>
          </div>
          <div class="modal-footer" style="margin-top: auto; padding: 0px">
            <div class="form-group pull-right">
              <div class="col-sm-12">
                <button type="button" class="btn btn-primary" @click="closeAudienceSelection">Cancel</button>
                <button type="submit" class="btn btn-primary">Send Test</button> 
              </div>
            </div>
          </div>
      </div>
    </div>
    </form>
    <reengagementDeleteModal
      v-if="isDeleteConfirmationVisible"        
      @close="closeConfirmationModal" 
      @deleteReengagement="deleteReengagement"
      :isDeleteConfirmationVisible="isDeleteConfirmationVisible"
      confirmationMessage="Are you sure you want to delete this Reengagement ?" 
      actionToBePerformed="Delete Reengagement"
    />
    <copyReengagementModal
      v-if="showCopyReengagementModal"
      @close="closeCopyModal"
      :showCopyReengagementModal="showCopyReengagementModal"
      @copyReengagement="copyReengagement"
      :currentName="currentName"
      :restoredValues="restoredValues"
    />
    
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>   
  </div>  
  
</template>
<script>
import Paginate from 'vuejs-paginate'
import deployedReportModal from './deployedReport'
import scheduledReportModal from './scheduledReport'
import failedReportModal from './failedReport'
import api from '../../../utils/api'
import { required } from 'vuelidate/lib/validators'
import { formatDate } from '../../../utils/utilities'
import _ from 'lodash'
import reengagementDeleteModal from '../popup/deleteConfirmation.vue'
import { REENGAGEMENT_STATUS } from './constant'
import copyReengagementModal from './copyModal'
import moment from 'moment'

export default {
  name: 'reengagementList',
  components: {
    'paginate': Paginate,
    'deployedReportModal': deployedReportModal,
    'reengagementDeleteModal': reengagementDeleteModal,
    'scheduledReportModal': scheduledReportModal,
    'failedReportModal': failedReportModal,
    'copyReengagementModal': copyReengagementModal
  },
  validations: {
    selectedUsers: { required },
    selectedGroup: { required }
  },
  data () {
    return {
      loading: false,
      schedulePageCount: 0,
      scheduleCurrentPage: 1,
      deployPageCount: 0,
      deployCurrentPage: 1,
      failePageCount: 0,
      failCurrentPage: 1,
      pageSize: 20,
      fromDt: '',
      toDt: '',
      searchReengagement: '',
      formatDate: formatDate,
      showDeployedReportModal: false,
      showScheduledReportModal: false,
      showFailedReportModal: false,
      audienceSelectionVisible: false,
      selectedUsers: [],
      selectedGroup: null,
      userList: [],
      deployedReport: {
        messagesSentCount: 0,
        messageDeliveredCount: 0,
        nudegeReplyCount: 0,
        reachToDestinationCount: 0,
        messagesFailed: 0,
        messagesFailedReasons: []
      },
      failureReport: {
        messagesFailed: 0,
        messagesFailedReasons: []
      },
      scheduledReport: {
        estimatedAudienceCount: 0
      },
      campaignDetails: {},
      selectedReengagement: undefined,
      submittedTestNudge: false,
      scheduledreengagementList: [],
      deployedreengagementList: [],
      failedreengagementList: [],
      isDeleteConfirmationVisible: false,
      campaignId: '',
      reengagementStatus: REENGAGEMENT_STATUS,
      showCopyReengagementModal: false,
      currentName: '',
      reengagementObj: {},
      timezone: '',
      deploymentDate: '',
      deploymentTime: '',
      schedule: '',
      restoredValues: {},
      newName: ''
    }
  },
  async mounted () {
    await this.fetchAllReengagementList()
  },
  watch: {
    searchReengagement: async function () {
      if (this.searchReengagement === '') {
        this.deployCurrentPage = 1
        this.scheduleCurrentPage = 1
        this.failCurrentPage = 1
        await this.fetchAllReengagementList()
      }
    }
  },
  methods: {
    openDeleteModal (id) {
      this.campaignId = id
      this.isDeleteConfirmationVisible = true
    },
    closeCopyModal () {
      this.showCopyReengagementModal = false
      this.currentName = ''
      this.restoredValues = {}
    },
    async getTimeZone (param) {
      try {
        const response = await api.buildRequest(`getTimezone`, 'POST', param)
        this.timezone = response.data.payload
      } catch (error) {
        this.$swal({
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    },

    handleTimeZoneChange () {
      // Convert Country specific time to UTC
      const time = moment.tz(`${this.deploymentDate} ${this.deploymentTime}`, this.timezone)
      this.schedule = time.utc().format()
      return
    },

    async copyReengagement (value) {
      this.showCopyReengagementModal = false
      await this.getTimeZone({ country: this.reengagementObj.country_name })
      this.deploymentDate = value.deploymentDate
      this.deploymentTime = value.deploymentTime
      this.newName = value.name
      if (this.deploymentDate !== '' && this.deploymentTime !== '') {
        this.handleTimeZoneChange()
      }
      const reengagementDetails = {
        campaign_name: value.name ? value.name : null,
        campaign_type: this.reengagementObj.campaign_type ? this.reengagementObj.campaign_type : null,
        country_id: this.reengagementObj.country_id ? this.reengagementObj.country_id : null,
        audience_id: null,
        status: 'Draft',
        schedule: this.schedule ? this.schedule : null,
        split_type: this.reengagementObj.split_type ? this.reengagementObj.split_type : null,
        group_list: this.reengagementObj.group_list ? this.reengagementObj.group_list : []
      }
      try {
        this.loading = true
        const response = await api.buildRequest('/createReengagement', 'POST', reengagementDetails)
        this.loading = false
        this.$swal({
          title: 'Success',
          type: 'success',
          text: response.data.payload.message ? response.data.payload.message : 'Created reengagement successfully'
        }).then(async () => {
          await this.fetchreengagementList(this.reengagementStatus.Scheduled)
        })
      } catch (err) {
        this.loading = false
        this.$swal({
          title: 'Failure',
          type: 'error',
          text: err.response.data.payload.message ? err.response.data.payload.message : 'Error while creating reengagement'
        }).then(() => {
          this.restoredValues = {
            name: this.newName,
            deploymentDate: this.deploymentDate,
            deploymentTime: this.deploymentTime
          }
          this.showCopyReengagementModal = true
        })
      }
    },

    openCopyModal (reengagementObj) {
      this.currentName = reengagementObj.campaign_name
      this.reengagementObj = reengagementObj
      this.showCopyReengagementModal = true
    },

    closeConfirmationModal () {
      this.isDeleteConfirmationVisible = false
    },

    async fetchCampaignDetails (id) {
      try {
        const campaignDetails = await api.buildRequest('fetchCampaignDetails', 'GET', {campaignId: id})
        this.campaignDetails = campaignDetails.data.payload
      } catch (err) {
        this.loading = false
        this.$swal({
          type: 'error',
          text: err.response ? err.response.data.payload.message : 'An error occurred'
        })
      }
    },

    async fetchReengagementReport (id, action, audienceId) {
      this.loading = true
      try {
        if (action === this.reengagementStatus.Deployed) {
          const response = await api.buildRequest('fetchDeployedReengagementReport', 'POST', { campaignId: id })
          const data = response.data.payload

          this.deployedReport = data.deployedReportObject.map((item, i) => Object.assign({}, item, data.failedReportObject[i]))

          await this.fetchCampaignDetails(id)
          this.showDeployedReportModal = true
        } else if (action === this.reengagementStatus.Scheduled) {
          const response = await api.buildRequest('fetchEstimatedReport', 'POST', { audienceId: audienceId })
          const data = response.data.payload
          this.scheduledReport = {
            estimatedAudienceCount: data.estimatedAudienceCount
          }
          await this.fetchCampaignDetails(id)
          this.showScheduledReportModal = true
        } else if (action === this.reengagementStatus.Failed) {
          const response = await api.buildRequest('fetchFailedReengagementReport', 'POST', { campaignId: id })
          const data = response.data.payload
          this.failureReport = data.failedReportObject
          await this.fetchCampaignDetails(id)
          this.showFailedReportModal = true
        }
        this.loading = false
      } catch (err) {
        this.loading = false
        this.$swal({
          type: 'error',
          text: err.response ? err.response.data.payload.message : 'An error occurred'
        })
      }
    },

    async testNudgeClick (campaign) {
      this.selectedReengagement = campaign

      this.loading = true
      try {
        const remData = await api.buildRequest('fetchCampaignDetails', 'GET', { campaignId: campaign.id })
        this.selectedReengagement = remData.data.payload

        const response = await api.buildRequest('getUsersToSendTestNudges', 'POST', {countryId: campaign.country_id})
        this.userList = response.data.payload.filter(i => i.id !== 0).map(i => { return { ...i, label: i.query_name } })
        this.audienceSelectionVisible = true
        this.loading = false
      } catch (err) {
        this.audienceSelectionVisible = true
        this.loading = false
        this.selectedUsers = []
        this.selectedGroup = null
        this.$swal({
          type: 'error',
          text: err.response ? err.response.data.payload.message : 'An error occurred'
        })
      }
    },
    async sendTestNudge () {
      this.submittedTestNudge = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      try {
        this.audienceSelectionVisible = false
        this.loading = true
        this.submittedTestNudge = false
        this.selectedGroup.country_id = this.selectedReengagement.country_id
        this.selectedGroup.country = this.selectedReengagement.country
        this.selectedGroup.group_id = this.selectedGroup.id
        this.selectedGroup.reengagement_id = this.selectedReengagement.id
        this.selectedGroup.context = 'REM_GROUP'
        const response = await api.buildRequest('sendTestNudge', 'POST',
          {
            campaign: this.selectedGroup, // TODO
            audience: this.selectedUsers
          }
        )
        this.loading = false
        this.$swal({
          type: 'success',
          text: response ? response.data.payload : 'Message sent successfully'
        })
        this.selectedUsers = []
        this.selectedGroup = null
      } catch (err) {
        this.loading = false
        this.audienceSelectionVisible = true
        this.$swal({
          type: 'error',
          text: err.response ? err.response.data.payload.message : 'An error occurred'
        })
      }
    },
    getDataForSchedulePage (pageNum) {
      this.scheduleCurrentPage = pageNum
      this.fetchreengagementList(this.reengagementStatus.Scheduled)
    },

    getDataForDeployPage (pageNum) {
      this.deployCurrentPage = pageNum
      this.fetchreengagementList(this.reengagementStatus.Deployed)
    },

    getDataForFailPage (pageNum) {
      this.failCurrentPage = pageNum
      this.fetchreengagementList(this.reengagementStatus.Failed)
    },

    async fetchreengagementList (status) {
      let skip = 0
      if (status === this.reengagementStatus.Deployed) {
        if (this.deployCurrentPage > 1) {
          skip = (this.deployCurrentPage - 1) * this.pageSize
        }
      } else if (status === this.reengagementStatus.Scheduled) {
        if (this.scheduleCurrentPage > 1) {
          skip = (this.scheduleCurrentPage - 1) * this.pageSize
        }
      } else {
        if (this.failCurrentPage > 1) {
          skip = (this.failCurrentPage - 1) * this.pageSize
        }
      }
      this.loading = true
      let queryParams = {
        skip: skip,
        limit: this.pageSize,
        searchText: this.searchReengagement || '',
        fromDt: this.fromDt || '',
        toDt: this.toDt || '',
        status: status
      }
      try {
        const response = await api.buildRequest('getReengagements', 'POST', queryParams)
        this.loading = false
        if (status === this.reengagementStatus.Deployed) {
          this.deployedreengagementList = response.data.payload.reengagementList
          this.deployPageCount = Math.ceil(response.data.payload.reengagementCount / this.pageSize)
        } else if (status === this.reengagementStatus.Scheduled) {
          this.scheduledreengagementList = response.data.payload.reengagementList
          this.schedulePageCount = Math.ceil(response.data.payload.reengagementCount / this.pageSize)
        } else {
          this.failedreengagementList = response.data.payload.reengagementList
          this.failePageCount = Math.ceil(response.data.payload.reengagementCount / this.pageSize)
        }
      } catch (err) {
        this.loading = false
        this.$swal({
          type: 'error',
          text: err.response ? err.response.data.payload.message : 'An error occurred'
        })
      }
    },
    closeAudienceSelection () {
      this.audienceSelectionVisible = false
      this.submittedTestNudge = false
      this.selectedUsers = []
      this.selectedGroup = null
    },

    async getReengagementReport (reengagement, action) {
      await this.fetchReengagementReport(reengagement.id, action, reengagement.audience_id)
    },

    async deleteReengagement () {
      try {
        this.isDeleteConfirmationVisible = false
        this.loading = true
        const response = await api.buildRequest('deleteReengagement', 'POST', { campaignId: this.campaignId })
        this.fetchreengagementList(this.reengagementStatus.Scheduled)
        this.$swal({
          type: 'success',
          text: response ? response.data.payload.message : 'Deleted reengagement successfully'
        })
      } catch (err) {
        this.loading = false
        this.$swal({
          type: 'error',
          text: err.response ? err.response.data.payload.message : 'An error occurred'
        })
      }
    },

    sortReengagement (sortKey, order, action) {
      if (action === 'deployed') {
        this.deployedreengagementList = _.sortBy(this.deployedreengagementList, [sortKey], function (camp) {
          return camp[sortKey].toLowerCase()
        })
        if (order === 'desc') {
          this.deployedreengagementList = _.reverse(this.deployedreengagementList)
        }
      } else {
        this.scheduledreengagementList = _.sortBy(this.scheduledreengagementList, [sortKey], function (camp) {
          return camp[sortKey].toLowerCase()
        })
        if (order === 'desc') {
          this.scheduledreengagementList = _.reverse(this.scheduledreengagementList)
        }
      }
    },

    async clearDate (dateName) {
      if (dateName === 'fromDt') {
        this.fromDt = ''
      }
      if (dateName === 'toDt') {
        this.toDt = ''
      }
      if (this.fromDt === '' && this.toDt === '') {
        await this.fetchAllReengagementList()
      }
    },

    async fetchAllReengagementList () {
      await this.fetchreengagementList(this.reengagementStatus.Scheduled)
      await this.fetchreengagementList(this.reengagementStatus.Deployed)
      await this.fetchreengagementList(this.reengagementStatus.Failed)
    },

    async searchReengagementWithSelectedCriteria (event) {
      this.deployCurrentPage = 1
      this.scheduleCurrentPage = 1
      this.failCurrentPage = 1
      if (this.searchReengagement !== '' && this.searchReengagement !== undefined) {
        if (event.key === 'Enter') {
          await this.fetchAllReengagementList()
        }
      } else if (this.fromDt && this.toDt) {
        await this.fetchAllReengagementList()
      }
    },

    closeReport (action) {
      if (action === this.reengagementStatus.Deployed) {
        this.showDeployedReportModal = false
      } else if (action === this.reengagementStatus.Scheduled) {
        this.showScheduledReportModal = false
      } else if (action === this.reengagementStatus.Failed) {
        this.showFailedReportModal = false
      }
      this.campaignDetails = {}
    }
  }
}
</script>
<style>
.test-nudge-container {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 600px;
    width: 100%;
    padding: 0px 20px;
    margin-right: 20px;
}
#swal2-content {
  white-space: pre-line;
}
.modal-user-selection {
  max-width:800px;
  padding-top: 40px;
  padding-left: 40px;
  height: 600px;
}
.modal-label {
  font-size: 20px;
  margin-bottom: 10px !important;
}
.search-box-reset {
  position: relative;
  cursor: default;
  top: 0px!important;
  left: 0px;
}
.align-center {
  text-align: center !important;
}
.search-reengagement {
  margin-top: 0px;
  margin-left: 0px;
}
.create-reengagement {
  margin-top: 24px !important;
}
.mrgn-right-20px {
  margin-right: 20px;
}
.loader {
  z-index: 9999;
  position: fixed;
  transform: translate(-50%,-50%);
  top:50%;
  left:50%;
}
.noaction {
  cursor: pointer;
  pointer-events: none;
}
.pagination {
  display: inline-block;
  margin-top: 0;
}

.pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
}
.searchBox {
  width: 250px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
  padding: 0 15px;
}
.margin-bottom-0px {
  margin-bottom: 0px; 
}
.cursor-pointer {
  cursor: pointer;
}
.thead-dark {
  background-color: #f5f5f5;
  border-color: #ddd;
  height: 40px;
}
.padding-left5px {
  padding-left: 5px;
}
.link-action-color {
  color:#0D9488
}
.reengagement-group-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// reengagementList.vue?d4c47fd2